import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchChapters, fetchBook } from '../../actions';
import BookLink from './book-link';

class TableOfContents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bId: this.props.match.params.bookID,
    };
  }

  componentDidMount() {
    this.props.fetchBook(this.state.bId);
    this.props.fetchChapters(this.state.bId);
  }

  renderCreateChapter = () => {
    if (this.props.loggedIn) {
      return (
        <BookLink className="create-link" to={`/books/${this.state.bId}/chapters/new`}>
          <button type="button" id="create-chapter">
            <i className="fas fa-scroll" />
            <p>Start a New Chapter</p>
          </button>
        </BookLink>
      );
    } else {
      return (
        <div className="signin-prompt">
          <p>Sign in to add a new chapter to this book.</p>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="toc-container">
        <div className="table-of-contents">
          <h1>Table of Contents</h1>
          {this.props.chapters.map((chapter) => {
            return (
              <div className="chapter-listing" key={chapter?.id}>
                <BookLink className="chapter-link" key={chapter.id} to={`/books/${this.props.currentBook.id}/chapters/${chapter.id}/pages`}>
                  <h1 className="chapter-title">{chapter.title}</h1>
                </BookLink>
                <span className="filler">.......................................................................................................................................................</span>
                <div className="chapter-number" />
              </div>
            );
          })}
          {this.renderCreateChapter()}
        </div>
      </div>
    );
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state) => (
  {
    currentBook: state.books.current,
    chapters: state.chapters.all,
    loggedIn: state.auth.authenticated,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
export default withRouter(connect(mapStateToProps, { fetchChapters, fetchBook })(TableOfContents));
